"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _ChannelSearch = _interopRequireDefault(require("./ChannelSearch"));
var _RescanInstructions = _interopRequireDefault(require("./RescanInstructions"));
var _DeviceAndPlatformLists = _interopRequireDefault(require("./DeviceAndPlatformLists"));
var _GeneralErrorBoundry = _interopRequireDefault(require("../../error-boundries/GeneralErrorBoundry"));
var _getViewingPlatforms = require("../../utils/getViewingPlatforms");
var _FindUsModule = _interopRequireDefault(require("../../scss/layouts/FindUs.module.scss"));
require("../../scss/layouts/FindUs.scss");
function FindUs(_ref) {
  let {
    network,
    baseApiUrl,
    platformsApiUrl = 'https://api.scrippscloud.com/viewing-platforms/v1',
    authApiUrl = '',
    allowStateSearch = true,
    allowZipcodeSearch = true,
    allowAutoScroll = true,
    autoScrollOffset = 25,
    compactLayout = true,
    platformResources = {},
    ad = {
      campaign: '',
      source: '',
      medium: 'referral',
      content: 'learn_more'
    }
  } = _ref;
  const [platforms, setPlatforms] = (0, _react.useState)(null);
  (0, _react.useEffect)(() => {
    if (platforms === null) {
      ;
      (async () => {
        const pfms = await (0, _getViewingPlatforms.getViewingPlatforms)({
          queryKey: ['', {
            network: network.platformsSlug,
            baseApiUrl: platformsApiUrl
          }]
        });
        setPlatforms(pfms);
      })();
    }
  }, [platforms, network.platformsSlug, platformsApiUrl]);
  return /*#__PURE__*/_react.default.createElement("section", {
    className: [_FindUsModule.default['find-us'], compactLayout ? 'find-us--compact' : ''].join(' ')
  }, !compactLayout && /*#__PURE__*/_react.default.createElement(_GeneralErrorBoundry.default, {
    errorTitle: "We're sorry, there's currently an issue with our channel search.",
    errorMessage: "Please try again later. If the problem persists please use the <strong>contact us</strong> link below to report the issue."
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "find-us__channel-search-section"
  }, /*#__PURE__*/_react.default.createElement(_ChannelSearch.default, {
    network: network,
    baseApiUrl: baseApiUrl,
    authApiUrl: authApiUrl,
    allowZipcodeSearch: allowZipcodeSearch,
    allowStateSearch: allowStateSearch,
    allowAutoScroll: allowAutoScroll,
    autoScrollOffset: autoScrollOffset,
    compactLayout: compactLayout,
    ad: ad
  }))), /*#__PURE__*/_react.default.createElement("div", {
    className: "find-us__rescan-platform-section"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: [_FindUsModule.default['grid-wrapper'], 'findus__grid-wrapper'].join(' ')
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: [_FindUsModule.default['findus__column'], 'findus__column'].join(' ')
  }, compactLayout && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("h4", {
    className: "channel-search__header"
  }, "Digital Antenna ", /*#__PURE__*/_react.default.createElement("span", {
    className: "channel-search__header--lighter"
  }, "(Over-the-Air Broadcast)")), /*#__PURE__*/_react.default.createElement(_GeneralErrorBoundry.default, {
    errorTitle: "We're sorry, there's currently an issue with our channel search.",
    errorMessage: "Please try again later. If the problem persists please use the <strong>contact us</strong> link below to report the issue."
  }, /*#__PURE__*/_react.default.createElement(_ChannelSearch.default, {
    network: network,
    baseApiUrl: baseApiUrl,
    authApiUrl: authApiUrl,
    allowZipcodeSearch: allowZipcodeSearch,
    allowStateSearch: allowStateSearch,
    allowAutoScroll: allowAutoScroll,
    autoScrollOffset: autoScrollOffset,
    compactLayout: compactLayout
  }))), /*#__PURE__*/_react.default.createElement(_RescanInstructions.default, {
    brandName: network.brand_name
  })), /*#__PURE__*/_react.default.createElement(_GeneralErrorBoundry.default, {
    errorTitle: "We're sorry, there's currently an issue with our device and platform lists.",
    errorMessage: "Please try again later. If the problem persists please use the <strong>contact us</strong> link below to report the issue."
  }, platforms !== null && platforms.size > 0 && platforms.get('error') === undefined && /*#__PURE__*/_react.default.createElement(_DeviceAndPlatformLists.default, {
    platformResources: platforms
  }), platforms !== null && platforms.size === 0 && /*#__PURE__*/_react.default.createElement("div", {
    className: "find-us__error"
  }, /*#__PURE__*/_react.default.createElement("p", {
    className: "find-us__error-message"
  }, "We couldn't find any viewing platforms for ", network.brand_name, "."))))));
}
var _default = exports.default = FindUs;